import type { FaireProductEntity } from "../../entity_types/product";

export const legacy_prod_abbott_102: FaireProductEntity = {
  token: "legacy_prod_abbott-102",
  type: "product",
  name: 'Mini Low Pumpkin Planter 4" W',
  brandName: "Abbott",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/0d685151e90aa1b88cb853a12c261e1cb0e44a6dab86460631657abed4caf5e4.jpeg",
  priceDollars: 16,
  subcategory: "Planters",
  brandToken: "catalog_brand_abbott",
  description: "",
  tags: [],
  categoryTokens: ["catalog_cat_garden-outdoor"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "common-sets-db-backfill",
  },
};
